import { FC, ReactNode } from 'react'
import { Text, TextTag, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'

type ContractNavigationGroupProps = {
  label: string
  children: ReactNode
}

export const ContractNavigationGroup: FC<ContractNavigationGroupProps> = ({ label, children }) => {
  return (
    <>
      <Text className={styles.navigationGroupLabel} variant={TextVariant.BodySmall} tag={TextTag.Span}>
        {label}
      </Text>
      <ul className={styles.navigationList}>{children}</ul>
    </>
  )
}
